<template>
  <UserResetPassword />
</template>

<script>
  import UserResetPassword from "@/components/UserResetPassword.vue";
  export default {
    name: "UserResetPasswordPage",
    components: {
      UserResetPassword,
    },
  };
</script>
